<goatsports-new-version-banner />
<router-outlet></router-outlet>
